import React from 'react';
import { connect } from 'react-redux';
import { func } from 'prop-types';
import { Spinner } from '@noths/shared-components';
import { Hub } from '@aws-amplify/core';
import Types from '../../redux/types';
import { SpinnerWrapper } from '../SignOut/styles';

export class SocialAuthRedirect extends React.Component {
  static propTypes = {
    signedInViaFacebook: func.isRequired,
  };

  constructor() {
    super();
    Hub.listen('auth', this);
  }

  onHubCapsule(capsule) {
    if (capsule.payload.event === 'signIn') {
      this.props.signedInViaFacebook();
    }
  }

  render() {
    return (
      <SpinnerWrapper>
        <Spinner />
      </SpinnerWrapper>
    );
  }
}

export default connect(
  null,
  dispatch => ({
    signedInViaFacebook: () => dispatch({ type: Types.SIGNED_IN_VIA_FACEBOOK }),
  })
)(SocialAuthRedirect);
